// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import _ from 'lodash';
import moment from 'moment'
import VueLazyload from 'vue-lazyload'
// import VueGtm from '@gtm-support/vue2-gtm';

Vue.use(VueLazyload, {
  preLoad: 10.0,
  loading: 'https://res.cloudinary.com/sirrus/image/upload/v1614611800/delivery/delivery/download_pl5ymc.png',
  error: 'https://res.cloudinary.com/sirrus/image/upload/v1614611800/delivery/delivery/error_huspix.png',
  attempt: 1,
  observer: true,
})


Vue.use(VueTheMask)
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  precision: 2,
  masked: false
})

Vue.prototype.momentJs = moment

require('@/assets/css/materialize.css')
require('@/assets/css/style.css')
require('@/assets/js/materialize.js?v=1.1')
require('@/assets/js/init.js?v=1.1')

Vue.use(Vuex)
Vue.config.productionTip = false

export const store = new Vuex.Store({
  state: {
    //apiUrl: 'http://10.22.59.50:8000/api/',
    //apiUrl: 'https://homologacao.sirruscook.app/api/',
    // apiUrl: 'http://127.0.0.1:8000/api/',
    is_producao: true,
    apiUrl: 'https://cloud.sirruscook.app/api/',
    empresa_url: '',
    empresa: {},
    grupos: [],
    produtosDestaque: [],
    produtosDestaqueBool: false,
    produto: {},
    pedido: {
      itens: []
    },
    cupom_desconto: "",
    cupom_desconto_valor: 0.00,
    multilink_ativo: false,
    is_cliente_logado: false,
    ultimo_pedido_cliente_logado: null,
    exibir_popup_ultimo_pedido: true,
    url_multilink: ''
  },
  mutations: {
    isClienteLogado(state, is_cliente_logado) {
      state.is_cliente_logado = is_cliente_logado;
    },
    empresaUrl(state, empresa_url) {
      state.empresa_url = empresa_url;
    },
    produtosPromocao(state, promocoes) {
      state.produtosPromocao = promocoes
    },    
    empresa(state, empresa) {

      document.title = "Sirrus Delivery - " + empresa.nome;

      var style = document.getElementById('cssEmpresa');

      if (!style) {
        style = document.createElement('style');
        style.id = 'cssEmpresa';
        style.type = 'text/css';
        document.getElementsByTagName('head')[0].appendChild(style);
      }

      style.innerHTML =
        '.cor-primaria-text { color: ' + empresa.cor_primaria + ' !important; } ' +
        '.cor-primaria-bg { background-color: ' + empresa.cor_primaria + ' !important; } ' +
        '.cor-primaria-border { border-color: ' + empresa.cor_primaria + ' !important; } ' +
        '.cor-primaria-divider { border-color: ' + empresa.cor_primaria + '4d !important; } ' +

        '.character-counter { color: ' + empresa.cor_primaria + ' !important; } ' +

        'input:not([type]):focus:not([readonly]), input[type=text]:not(.browser-default):focus:not([readonly]), input[type=password]:not(.browser-default):focus:not([readonly]), input[type=email]:not(.browser-default):focus:not([readonly]), input[type=url]:not(.browser-default):focus:not([readonly]), input[type=time]:not(.browser-default):focus:not([readonly]), input[type=date]:not(.browser-default):focus:not([readonly]), input[type=datetime]:not(.browser-default):focus:not([readonly]), input[type=datetime-local]:not(.browser-default):focus:not([readonly]), input[type=tel]:not(.browser-default):focus:not([readonly]), input[type=number]:not(.browser-default):focus:not([readonly]), input[type=search]:not(.browser-default):focus:not([readonly]), textarea.materialize-textarea:focus:not([readonly]) { border-bottom: 1px solid ' + empresa.cor_primaria + ' !important; -webkit-box-shadow: 0 1px 0 0 ' + empresa.cor_primaria + ' !important; box-shadow: 0 1px 0 0 ' + empresa.cor_primaria + ' !important; } ' +

        '[type="checkbox"].filled-in:not(:checked) + span:not(.lever):after { border-color: ' + empresa.cor_primaria + ' !important; } ' +
        '[type="checkbox"].filled-in:checked + span:not(.lever):after { background-color: ' + empresa.cor_primaria + ' !important; border-color: ' + empresa.cor_primaria + ' !important; } ' +
        '.switch label input[type=checkbox]:checked + .lever { background-color: ' + empresa.cor_primaria + '99 !important; } ' +
        '.switch label .lever:before { background-color: ' + empresa.cor_primaria + '26 !important; } ' +
        '.switch label input[type=checkbox]:checked + .lever:after { background-color: ' + empresa.cor_primaria + ' !important; } ' +

        '[type="radio"]:not(:checked) + span:before, [type="radio"]:not(:checked) + span:after { border: 2px solid ' + empresa.cor_primaria + ' !important; } ' +
        '[type="radio"]:checked + span:after, [type="radio"].with-gap:checked + span:after { background-color: ' + empresa.cor_primaria + ' !important; } ' +
        '[type="radio"]:checked + span:after, [type="radio"].with-gap:checked + span:before, [type="radio"].with-gap:checked + span:after { border: 2px solid ' + empresa.cor_primaria + ' !important; } ' +

        '.cor-secundaria-bg { background-color: ' + empresa.cor_secundaria + ' !important; } ' +

        '.splash-cor-1 { color: ' + empresa.splash_cor_1 + ' !important; } ' +
        '.splash-cor-2 { color: ' + empresa.splash_cor_2 + ' !important; }';

      if (!empresa.facebook_pixel)
        empresa.usa_facebook_pixel = "N";

      if (!empresa.codigo_gtm)
        empresa.usa_google_gtm = "N";

      if (empresa.usa_facebook_pixel == "S" && fbq.getState().pixels.length == 0) {

        fbq.track = "track";
        fbq.src = "";

        if (location.search.indexOf("src=facebook") != -1) {
          fbq.track = "trackCustom";
          fbq.src = "_facebook";
        }
        else if (location.search.indexOf("src=instagram") != -1) {
          fbq.track = "trackCustom";
          fbq.src = "_instagram";
        }

        fbq('init', empresa.facebook_pixel);
        fbq('trackCustom', 'InitiatePixel' + fbq.src);
      }

      if (empresa.usa_google_gtm == "S") {
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({
            'gtm.start':
              new Date().getTime(), event: 'gtm.js'
          }); var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
              'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', empresa.codigo_gtm);
      }

      state.empresa = empresa;
    },
    grupos(state, grupos) {
      state.grupos = grupos;
    },
    produto(state, produto) {
      state.produto = $.extend(true, {}, produto);
    },
    pedido(state, pedido) {
      state.pedido = pedido;
    },
    adicionar_item_pedido(state, item) {
      state.pedido.itens.push($.extend(true, {}, item));
    },
    adicionar_item_pedido_carrinho(state, item) {
      const existingItem = state.pedido.itens.find(i => i.id === item.id);

      if (existingItem) {
        existingItem.quantidade = item.quantidade;
      } else {
        state.pedido.itens.push(item);
      }
    },
    remover_item_pedido(state, itemRemover) {
      let forDeletion = [];
      forDeletion.push(itemRemover);
      state.pedido.itens = state.pedido.itens.filter(item => !forDeletion.includes(item));
    },
    remover_item_adicional_pedido(state, objetoItemAdicional) {
      let forDeletion = [];
      forDeletion.push(objetoItemAdicional.adicional);

      objetoItemAdicional.item.adicionais = objetoItemAdicional.item.adicionais.filter(item => !forDeletion.includes(item));

      const index = state.pedido.itens.findIndex(project => project === objetoItemAdicional.item);
      state.pedido.itens[index] = objetoItemAdicional.item;
    },
    produtosDestaque(state, produtosDestaque) {
      state.produtosDestaque = produtosDestaque;
    },
    produtosDestaqueBool(state, produtosDestaqueBool) {
      state.produtosDestaqueBool = produtosDestaqueBool;
    },
  },
  getters: {
    getValorTotalPedido: state => {

      let subtotal = 0.00;
      var valorTotal = 0.00;
      state.pedido.itens.forEach(item => {
        let valorAdicional = 0.00;
        item.adicionais.forEach(adicional => {
          if (adicional) {
            valorAdicional += parseFloat(adicional.valor) * adicional.quantidade;
          }
        });

        subtotal += (parseFloat(item.valor) + valorAdicional) * item.quantidade;
      });
      valorTotal = subtotal - state.cupom_desconto_valor;
      return valorTotal.toFixed(2);

    },
    pedidoSubtotal: state => {
      let subtotal = 0.00;
      state.pedido.itens.forEach(item => {
        let valorAdicional = 0.00;
        item.adicionais.forEach(adicional => {
          if (adicional) {
            valorAdicional += parseFloat(adicional.valor) * adicional.quantidade;
          }
        });

        subtotal += (parseFloat(item.valor) + valorAdicional) * item.quantidade;
      });

      return subtotal;
    },
    pedidoSubtotalElegivelDesconto: state => {
      let subtotal = 0.00;
      state.pedido.itens.forEach(item => {
        // Só considera produtos que permitem cupom de desconto
        if (item.permite_cupom_desconto === 'S') {
          let valorAdicional = 0.00;
          item.adicionais.forEach(adicional => {
            if (adicional) {
              valorAdicional += parseFloat(adicional.valor) * adicional.quantidade;
            }
          });

          subtotal += (parseFloat(item.valor) + valorAdicional) * item.quantidade;
        }
      });

      return subtotal;
    },
    pedidoTotal: (state, getters) => {
      // Calcula o total dos produtos não elegíveis para desconto
      let totalNaoElegivel = getters.pedidoSubtotal - getters.pedidoSubtotalElegivelDesconto;
      // Aplica o desconto apenas sobre o subtotal elegível e adiciona o total não elegível
      return (getters.pedidoSubtotalElegivelDesconto - parseFloat(state.cupom_desconto_valor)) + totalNaoElegivel + parseFloat(state.empresa.taxa_entrega);
    }
  },
  mounted: {
    configureGTM(gtmId) {
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', gtmId);
    }
  }
});

Vue.prototype.$store = store;

router.beforeEach((to, from, next) => {
  if (from.query.src && !to.query.src) {
    if (to.path === from.path)
      return; // This is a no-no via the documentation, but a bug in routing to identical routes strips query params, and this prevents that

    next({ path: to.path, query: { src: from.query.src } });
  }

  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js